import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const SingleSelect = ({ options, selectedValue, handleChange, placeholderText, name, skipDefault = false, creatable = false }) => {
  const SelectComponent = creatable ? Creatable : Select;

  if (skipDefault) {
    return (
      <SelectComponent
        className="basic-single"
        name={name}
        components={animatedComponents}
        defaultValue={!skipDefault && selectedValue}
        value={selectedValue}
        options={options}
        onChange={handleChange}
        placeholder={placeholderText}
        isClearable={true}
      />
    );
  }

  return (
    <SelectComponent
      className="basic-single"
      name={name}
      components={animatedComponents}
      defaultValue={selectedValue}
      options={options}
      onChange={handleChange}
      placeholder={placeholderText}
      isClearable={true}
    />
  );
};

SingleSelect.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  creatable: PropTypes.bool,
};

SingleSelect.defaultProps = {
  name: null,
  options: [{}],
  selectedValue: null,
  creatable: false,
};

export default SingleSelect;
